import React, { useState } from 'react'
import './bud.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDollarSign, faHome, faHamburger, faCar, faPiggyBank } from '@fortawesome/free-solid-svg-icons';





function Budget() {


   
    


    var Val = document.getElementById("budgetSelection");
    // var s = document.getElementById("s");
    // var i = document.getElementById("i");
    // var c = document.getElementById("s");

    //setting Total value by user blank variable
    var Total1

    // variables to get id for budget selection amount
    var Savings = document.getElementById("Savings");
    var Investing = document.getElementById("Investing");
    var Housing = document.getElementById("Housing");
    var Food = document.getElementById("Food");
    var Transportation = document.getElementById("Transportation");
    var budgetSelection = document.getElementById("budgetSelection");

    // variables created to get id from budget Amounts
    var Sav = document.getElementById("Sav");
    var Inv = document.getElementById("Inv");
    var Hou = document.getElementById("Hou");
    var Foo = document.getElementById("Foo");
    var Tra = document.getElementById("Tra");

    // variables created for amount
    var amSav = document.getElementById("amSav");
    var amInv = document.getElementById("amInv");
    var amHou = document.getElementById("amHou");
    var amFoo = document.getElementById("amFoo");
    var amTra = document.getElementById("amTra");

    var amTot = document.getElementById("amTot");

   
    // variable to grab the value of Total Income
     var Total = document.getElementById("Total");
     

    // function for the budget percentages

    function ok() 
    
    { if (Val.value === "Investing"){
        console.log(1);
        
        Savings.value = 20 + "%";
        Investing.value = 45 + "%";
        Housing.value = 18 + "%";
        Food.value = 12 + "%";
        Transportation.value = 5 + "%";

    }   
        else if (Val.value === "Saving"){
        console.log(2);
        
        Savings.value = 35 + "%";
        Investing.value = 25 + "%";
        Housing.value = 25 + "%";
        Food.value = 10 + "%";
        Transportation.value = 5 + "%";
    } 
        else if (Val.value === "Custom"){
        console.log(3);
        
        Savings.value = 0 + "%";
        Investing.value = 0 + "%";
        Housing.value = 0 + "%";
        Food.value = 0 + "%";
        Transportation.value = 0 + "%";
    }   
}

    //function for the Budget section for calculations
    function budget () { if (Val.value === "Investing"){
        
        console.log(1);
        Sav.value = parseFloat((20 / 100) * Total.value).toFixed(2);
        Inv.value = parseFloat((45 / 100) * Total.value).toFixed(2);
        Hou.value = parseFloat((18 / 100) * Total.value).toFixed(2);
        Foo.value = parseFloat((12 / 100) * Total.value).toFixed(2);
        Tra.value = parseFloat((5 / 100) * Total.value).toFixed(2);

    }   
        else if (Val.value === "Saving"){
            console.log(2);
            Sav.value = parseFloat((35 / 100) * Total.value).toFixed(2);
            Inv.value = parseFloat((25 / 100) * Total.value).toFixed(2);
            Hou.value = parseFloat((25 / 100) * Total.value).toFixed(2);
            Foo.value = parseFloat((10 / 100) * Total.value).toFixed(2);
            Tra.value = parseFloat((5 / 100) * Total.value).toFixed(2);
    } 
        else if (Val.value === "Custom"){
            console.log(3);
            Sav.value = 0 + "$";
            Inv.value = 0 + "$";
            Hou.value = 0 + "$";
            Foo.value = 0 + "$";
            Tra.value = 0 + "$";
    }
    
}

    //testing color change functions
    function savColor() {
        Tot();
        if(parseFloat(amSav.value) > parseFloat(Sav.value)){
            console.log(4)
            amSav.style.color="red";
        } else {
            amSav.style.color="Green";
        } 
        
    }

    function invColor() {
        Tot();
        if(parseFloat(amInv.value) > parseFloat(Inv.value)){
            console.log(4)
            amInv.style.color="red";
        } else {
            amInv.style.color="Green";
        }
        
    }

    function houColor() {
        Tot();
        if(parseFloat(amHou.value) > parseFloat(Hou.value)){
            console.log(4)
            amHou.style.color="red";
        } else {
            amHou.style.color="Green";
        }
        
    }

    function fooColor() {
        Tot();
        if(parseFloat(amFoo.value) > parseFloat(Foo.value)){
            console.log(4)
            amFoo.style.color="red";
        } else {
            amFoo.style.color="Green";
        }
        
    }

    function traColor() {
        Tot();
        if(parseFloat(amTra.value) > parseFloat(Tra.value)){
            console.log(4)
            amTra.style.color="red";
        } else {
            amTra.style.color="Green";
        }
        
    }
    
    //const [ budgetState, setBudgetState] = useState("");
  function Tot(){
    amTot.value = parseFloat(amSav.value) + parseFloat(amTra.value) + parseFloat(amInv.value) + parseFloat(amHou.value) + parseFloat(amFoo.value)

    if(parseFloat(amTot.value) > Total.value ){
   
    amTot.style.color="red";
  } else {
    amTot.style.color="green";
  }
  }

    function onchange(){
        
        ok();
        budget();
        
    }
    
   const [budSel, setBudSel] = useState("Saving");
       
      
  

    return (
        

        <div>
           

            <div>
            <h3 className="in">Total Income</h3>
            <div className="BdApp">
            <label>$</label><input id="Total" type="number"  placeholder="Please enter a number" value={ Total1 }/>
            </div>
            </div>
                    <br/>
        <div>
            <label className="ush">Budget Selection</label>
                    <br/>
                    <select id="budgetSelection" 
                    className="BApp"  
                    value={budSel}
                    onChange={(e) => {
                        const selectedBud = e.target.value;
                        setBudSel(selectedBud);
                        
                    }}>
                            <option value="Please" >Please select a value</option>
                            <option id="s" value="Saving" >Savings</option>
                            <option id="i" value="Investing" >Investing</option>
                            <option id="c" value="Custom">Custom</option>
                        </select>
                        
           
             <div className="push"> 
            <div>       
            <label><FontAwesomeIcon 
            icon={ faPiggyBank } className="center"/></label>
                    <br/>
                        <input id="Savings" className="BbApp" defaultValue="0%"/>
            </div>

            <div>
            <label ><FontAwesomeIcon 
            icon={ faDollarSign } className="center1"/></label>
                    <br/>
                        <input id="Investing" className="BbApp" defaultValue="0%"/>
            </div> 

            <div>   
            <label><FontAwesomeIcon 
            icon={ faHome } className="center2"/></label>
                    <br/>
                        <input id="Housing" className="BbApp" defaultValue="0%"/>
            </div> 

            <div>
            <label><FontAwesomeIcon 
            icon={ faHamburger } className="center3"/></label>
                    <br/>
                        <input id="Food" className="BbApp" defaultValue="0%"/>
            </div>

            <div> 
            <label><FontAwesomeIcon 
            icon={ faCar } className="center4"/></label>
                    <br/>
                        <input id="Transportation" className="BbApp" defaultValue="0%"/>
            </div>
            </div> 
            
                        <button onClick={onchange} className="btn">Calculate</button>
            
        </div>                

           <div className="con">
           <FontAwesomeIcon 
            icon={ faPiggyBank } className="icon"/>
            <FontAwesomeIcon 
                    icon={ faDollarSign } className="icon1"/> 
            <FontAwesomeIcon 
                    icon={ faHome } className="icon"/>
            <FontAwesomeIcon 
                    icon={ faHamburger } className="icon"/>
            <FontAwesomeIcon 
                    icon={ faCar } className="icon"/> 

           </div>

        <div className="budget">
            <h3 className="title">Budget</h3>
           
                       
            <div className="BcApp">
            
            <label>$</label><input id="Sav" type="number" placeholder="0" />
            </div> 


                  
            <div className="BcApp">
            
                <label>$</label>
                    <input id="Inv" type="number" placeholder="0" />
            </div>   

               
            <div className="BcApp">   
                 
                <label>$</label>
                    <input id="Hou" type="number" placeholder="0" />
            </div>   

                 
            <div className="BcApp">
            
                    <label>$</label>
                        <input id="Foo" type="number" placeholder="0" />
            </div>   


                 
            <div className="BcApp">
                
                    <label>$</label>
                        <input id="Tra" type="number" placeholder="0" />
            </div> 
                     
                 
        </div>
                         
                            

        <div id="am" className="amount">
            <h3 className="title">Amount Spent</h3>

            
             <div className="BaApp">      
            <label>$</label><input id="amSav" onChange={savColor} type="number" defaultValue="0" />
            </div>    
            
                 <div className="BaApp">  
            <label>$</label><input id="amInv" onChange={invColor} type="number" defaultValue="0" />
            </div>   
            
                   <div className="BaApp">
            <label>$</label><input id="amHou" onChange={houColor} type="number" defaultValue="0" />
            </div>   
            
                    <div className="BaApp">
                        <label>$</label><input id="amFoo" onChange={fooColor} type="number" defaultValue="0" />
                    </div>   
            
                    <div className="BaApp">
                        <label>$</label><input id="amTra" onChange={traColor} type="number" defaultValue="0" />
                    </div>      
            </div> 
                    
                    <div className="title">
                        <h3 >Total</h3>
                        </div>
                    <div className="BdApp">
                        
                        <label>$</label><input id="amTot" defaultValue="0" />
                    </div>
        
        </div>
    )
}

export default Budget
